import React, { useEffect, useState, useRef } from "react";
import {
  ButtonPrimaryV2,
  DropdownSingle,
  ModalSmall,
  PaddingTop20,
  SANS_4_5,
  SANS_5_6
} from "oolib";
import { useAppSettingsContext } from "../contexts/appSettingsContext";
import { useGetQueryData } from "../utils/react-query-hooks/general";
import { useMXP_LangSelectModal } from "@/mixpanel/mixpanelHooks/useMXP_LangSelectModal";

export const LangSelectModal = () => {
  const { APP_SETTINGS, APP_SETTINGS_DISPATCH } = useAppSettingsContext();
  const {deployment} = useGetQueryData('platformConfigs');
  const [showFirstTimeLangSelectModal, setShowFirstTimeLangSelectModal] = useState(false);
  
  
  useEffect(() => {
    if (!localStorage.getItem("APP_LANG") && _AppLanguageOptions?.length > 1) {
      setShowFirstTimeLangSelectModal(true);
    }
  }, []);
  
  const {
    deployment: { _AppLanguageOptions },
  } = useGetQueryData("platformConfigs");
  

  const {
    onLangChange,
    trackProceed,
  } = useMXP_LangSelectModal({
    lang: APP_SETTINGS.lang,
    entryPoint: window.location.pathname,
  });

  const LangDropdown = (
    <DropdownSingle
      label='Choose a platform language'
      value={APP_SETTINGS.lang}
      options={_AppLanguageOptions}
      onChange={(k, v) => {
        APP_SETTINGS_DISPATCH({
          type: "SET_LANG",
          payload: v,
        });
        onLangChange(v)
      }}
      optionsClassName={"SANS_2"}
      selectClassName={"SANS_2"}
    />
  );
  
  
  return (
    <>
      {showFirstTimeLangSelectModal && (
        <ModalSmall
          disableHeader
          title="Choose a platform language">
          <SANS_5_6>{`Welcome to ${deployment._DeploymentDisplayName}!`}</SANS_5_6>
          <PaddingTop20/>
          {LangDropdown}
          <PaddingTop20/>
          <ButtonPrimaryV2
            children={'Proceed'}
            onClick={() => {
              trackProceed();
              
              APP_SETTINGS_DISPATCH({
                type: "SET_LANG",
                payload: APP_SETTINGS.lang,
              });
              
              if(showFirstTimeLangSelectModal){
                setShowFirstTimeLangSelectModal(false);
              }
            }}
          />
        </ModalSmall>
      )}
    </>
  );
};